export default "__VITE_ASSET__3ceDaejP__"